import React from 'react'
import { Query } from 'react-apollo'
import { LibraryAgentLanguage } from '../../components/library/library-agent-language'
import { libraryQuery } from './graphql-fragments'
import { Library } from '../../helpers/ui-interfaces'

export const buildLibraryCacheID = ({
  hash,
  language
}: {
  readonly hash: string
  readonly language: string
}) => `${hash}|${language}`

const parseLibraryCacheID = (id: string) => id.split('|')

interface LibraryQueryProps {
  readonly organizationID: string
  readonly rowDataID: string
  readonly children: (rowData: Library) => React.ReactNode
}

export function LibraryRowQuery({
  organizationID,
  rowDataID,
  children
}: LibraryQueryProps) {
  const [hash, language] = parseLibraryCacheID(rowDataID)
  return (
    <Query
      query={libraryQuery}
      fetchPolicy="cache-only"
      variables={{
        hash,
        language,
        organizationID
      }}
    >
      {({ data }) => {
        const {
          library: { language, ...library }
        } = data
        return children({
          ...library,
          language: LibraryAgentLanguage.fromValue(language)
        })
      }}
    </Query>
  )
}
